import { configureStore } from "@reduxjs/toolkit"

import adminReducer from "./pages/admin/reducer"
import customerReducer from "./pages/customer/reducer"
import workflowReducer from "./pages/customer/workflows/reducer"
import userReducer from "./pages/users/reducer"
import snackbarReducer from "./reducers/snackbar"

export default configureStore({
  reducer: {
    admin: adminReducer,
    user: userReducer,
    customer: customerReducer,
    workflow: workflowReducer,
    snackbar: snackbarReducer,
  },
})
